import { forwardRef } from "react"

interface PropertyTypeOption {
  label: string
  prefix?: string
  default?: boolean
  help_text?: string
  prefix_options?: { value: string; label: string; default?: boolean }[]
}

interface PropertyTypeSelectorProps {
  id: string
  name: string
  value: string
  options: Record<string, PropertyTypeOption>
  onChange: (value: string) => void
}

/**
 * Dropdown selector for property type selection with help text
 */
const PropertyTypeSelector = forwardRef<
  HTMLSelectElement,
  PropertyTypeSelectorProps
>(({ id, name, value, options, onChange }, ref) => {
  const selectedOption = options[value]

  return (
    <div className="space-y-3">
      <div className="flex flex-col gap-2 justify-start">
        <label
          htmlFor={id}
          className="text-base font-medium text-white text-left"
        >
          Property Type*
        </label>

        <select
          ref={ref}
          id={id}
          name={name}
          value={value}
          onChange={e => onChange(e.target.value)}
          className="w-full p-3 border border-gray-300 rounded-lg bg-white text-gray-900 focus:ring-2 focus:ring-basic-blue focus:border-basic-blue"
        >
          {Object.entries(options).map(([typeKey, option]) => (
            <option key={typeKey} value={typeKey}>
              {option.label}
            </option>
          ))}
        </select>

        {selectedOption?.help_text && (
          <div className="text-base text-cadet-blue mt-1">
            {selectedOption.help_text}
          </div>
        )}
      </div>
    </div>
  )
})

PropertyTypeSelector.displayName = "PropertyTypeSelector"

export default PropertyTypeSelector
